<div class="container-fluid bg-dark">
  <nav class="navbar navbar-expand-sm m-0 p-0">
    <!-- desktop navigation panel on left -->
    <div class="navbar-panel d-none d-md-block">
      <teacher-main-nav
        [theme]="theme"
        [activeSegments]="activeSegments"
        class="h-100"
      ></teacher-main-nav>
    </div>
  </nav>
  <!-- offcanvas menu on mobile -->
  <div
    class="offcanvas offcanvas-menu offcanvas-end"
    tabindex="-1"
    id="offcanvasWithBackdrop"
    aria-labelledby="offcanvasWithBackdropLabel"
  >
    <div class="offcanvas-body p-0 pt-4 pt-sm-0 d-flex">
      <teacher-main-nav
        [theme]="theme"
        [isOffcanvas]="true"
        [activeSegments]="activeSegments"
        [profilePhoto]="profilePhoto"
        class="w-100"
      ></teacher-main-nav>
    </div>
  </div>
  <router-outlet></router-outlet>
  <div *ngIf="!isAppNative && schoolId == 1" class="elfsight-app-ff036162-9f97-4c85-a480-8341b02632f6"></div>
</div>
